import BaseService from './BaseService'

class PosBootstrapService extends BaseService {
  constructor () {
    super('/pos')
  }

  /** POS register critical-path bootstrap payload. */
  async getBootstrap () {
    return this.customRequest('get', '/bootstrap')
  }
}

export const posBootstrapService = new PosBootstrapService()
